const AOS = require('aos');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  containerFix();
  submenuOffset();
  heroOffset();

  setTimeout(function() {
    defaultTax();

    if ($('#wcvat-toggle').hasClass('on')) {
      $('#wcvat-toggle').removeClass('on');
    }    
  }, 500);

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
  });
  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  // Search BTN
  $('#search-modal').on('shown.bs.modal', function () {
    $('.form-control').focus();
  }) 

  // Manufacturers Filter

  $('.manufacturer-btn').on('click', function(e){
    e.preventDefault();
    const dataVal = $(this).data('optionval');
    $('#manufacturer-filter').attr('value', dataVal);
    $('form#quantity-filter').trigger('submit');
  });

  // Breadcrumb menu stuff
  $('.submenu-toggle').on('click', function(){
    const toggle = $(this);
    const element = toggle.prev('a').text();
    const breadcrumb = toggle.next('.submenu-mobile').find('.breadcrumb-item');
    const breadcrumb_spans = breadcrumb.find('span');
    if (breadcrumb_spans.length === 0) {
      breadcrumb.append('<span>'+element+'</span>');
    } else {
      var check = 0;
      breadcrumb_spans.each(function(){
        const inner = $(this);
        const inner_text = inner.text();
        if (inner_text == element) {
          check = 1;
        }
      });
      if (check == 0) {
        breadcrumb.append('<span>'+element+'</span>');
      }
    }    
  });

  $('.submenu-back').on('click', function(){
    console.log('back-click');
    const back = $(this);
    const breadcrumb = back.parent('.nav-item').find('.breadcrumb-item');
    console.log(breadcrumb);
    breadcrumb.find('span:last').remove();
  });

  // // Sort stuff.
  // $('#sort-ref').on('change', function() {
  //   var sort = $(this).val();
  //   $('form.filters #sort-filter').attr('value', sort);
  //   $('form.filters').trigger('submit');
  // });

  // // Stock stuff.
  // $('#stock-ref').on('change', function() {
  //   var stock = $(this).prop('checked');
  //   $('form.filters #stock-filter').attr('value', stock);
  //   $('form.filters').trigger('submit');
  // });

  // // Delivery stuff.
  // $('#delivery-ref').on('change', function() {
  //   var delivery = $(this).val();
  //   $('form.filters #stock-delivery-filter').attr('value', delivery);
  //   $('form.filters').trigger('submit');
  // });

  // Count stuff.
  $('#count-ref').on('change', function() {
    var count = $(this).val();
    $('form#quantity-filter #count-filter').attr('value', count);
    var action = $('form#quantity-filter').attr('action');
    if (action && ~action.indexOf("/page/")) {
      action = action.substring(0, action.indexOf('page/'));
      $('form#quantity-filter').attr('action', action);
    }
    $('form#quantity-filter').trigger('submit');
  });

  // Single Product

  if($('.single_variation_wrap').find('.wc-pao-addons-container').length !== 0) {
    $(".woocommerce-variation").addClass('hasClass');
  }

  // Smooth scroll.
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function (event) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        var offset = $("header").outerHeight();
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000
          );
        }
      }
    });

  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
  });
  $("#burger-homepage").click(function () {
    open = !open;
    toggleMenu(open);
  });

  // Active class.
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) {
      $(this).addClass("active");
    }
  });

  function defaultTax() {
    // Hidden global price (excl VAT)
    var globalPrice = $('.summary .price .product-tax-off bdi').first().text();
    var priceNumber = parseFloat(globalPrice.replace(/[^\d.-]/g, ''));

    // Setting default price structure
    var defaultPrice = '£ ' + priceNumber.toFixed(2) + ' Excl. VAT';
    $('.bundle_price .price .woocommerce-Price-amount').text(defaultPrice);
  }

  function taxToggle() {
    // Bundle Loop
    var exclTax = 0;

    $('.bundled_product').each(function(index, element) {
      // Checkbox for loop
      var checkbox = $(element).find('.bundled_product_checkbox');
  
      // Get and convert price of current bundle (excl VAT)
      var checkedPrice = $(element).find('.price .product-tax-off bdi').text();
      var checkedNumber = parseFloat(checkedPrice.replace(/[^\d.-]/g, ''));
  
      // If statement to check if the current checkbox is checked
      if (checkbox.is(':checked')) {
        exclTax += checkedNumber; // Add the checked price to the default price
      }

      // Hidden global price (excl VAT)
      var globalPrice = $('.summary .price .product-tax-off bdi').first().text();
      var priceNumber = parseFloat(globalPrice.replace(/[^\d.-]/g, ''));
      var defaultPrice = priceNumber;

      // Setting default price
      defaultPrice += exclTax;
  
      // Adding VAT
      var increasedPrice = defaultPrice * 1.2;
  
      // Check if toggle has class (on)
      if ($('.wcvat-toggle-product').hasClass('on')) {
        var defaultText = '£ ' + defaultPrice.toFixed(2) + ' Excl. VAT';
        $('.bundle_price .price .woocommerce-Price-amount').text(defaultText);
      } else {
        var increasedText = '£ ' + increasedPrice.toFixed(2) + ' Incl. VAT';
        $('.bundle_price .price .woocommerce-Price-amount').text(increasedText);
      }
    });
  }

  $('.bundled_product_checkbox').on('change', function() {
    taxToggle();

    setTimeout(function() {
      if ($('.wcvat-toggle-product').hasClass('on')) {
        if (!$('.bundle_price .price .woocommerce-Price-amount').text().includes('Incl. VAT')) {
          $('.bundle_price .price .woocommerce-Price-amount').append(' Incl. VAT');
        }
      } else {
        if (!$('.bundle_price .price .woocommerce-Price-amount').text().includes('Excl. VAT')) {
          $('.bundle_price .price .woocommerce-Price-amount').append(' Excl. VAT');
        }
      }    
    }, 500);
  });

  // Fixing WooCommerce toggle styling

  $('.wcvat-toggle-product').on('click', function(){
    if($(this).hasClass('on')) {
      $(this).text('Show VAT');
    } else {
      $(this).text('Hide VAT');
    }

    taxToggle();
  });

  // Header Fix (If the header has a border inside keep the + 1 else remove it)
  function resizeLogic() {
    const heightHeader = $("header").height();
    $('.header-fix').height(heightHeader);
  }

  resizeLogic(); // on load
  $(window).resize(resizeLogic); // on window resize

  // Accordion Collapse 

  if ($(window).width() < 991) {
    if ($("#accordion-shop .accordion-button").not("collapsed")) {
      $("#accordion-shop .accordion-button").addClass("collapsed");
    };

    if ($("#accordion-shop .accordion-collapse").hasClass("show")) {
      $("#accordion-shop .accordion-collapse").removeClass("show");
    };
  };

  // Filter Styling 

  $("#accordion-shop .accordion-button").on("click", function () {
    if($(this).hasClass('collapsed')) {
      $(this).parent().addClass('header-collapsed');
    } else {
      $(this).parent().removeClass('header-collapsed');
    }
  });

  // Main Shop Filter Styling 

  $("#shop-accordion .accordion-button").on("click", function () {
    $(this).parent().toggleClass('header-collapsed');
  });

  // Guides filter

  $("#guides-accordion .accordion-button").on("click", function () {
    $(this).parent().toggleClass('header-open');
  });

  // Guides toggle

  $('.pdf-category').on('click', function(){
    // Sets a variable for category and the data attribute it has.
    var category = $(this);
    var data = category.data('ref');
    console.log('Category: ' + category);
    console.log('Data: ' + data);
    
    // Before we do anything, hide all category content.
    $('.pdf-category-content').addClass('d-none');
    $('.guide-prompt').addClass('d-none');
  
    // Target the category content via the data-ref attribute and add "d-block".
    $('.pdf-category-content[data-ref="'+data+'"]').removeClass('d-none');
    $('.pdf-category-content[data-ref="'+data+'"]').addClass('d-block');
    console.log('Targeted content: pdf-category-content[data-ref="'+data+'"]');
  });

  // Submenu.
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu-mobile");
    submenu.toggleClass('open');
    // submenu.children("ul").slideToggle("fast");
  });

  // Submenu 2.0
  $('.submenu-back').on('click', function(){
    var parent = $(this).parent('.nav-item').parent('.nav');
    var parent_parent = parent.parent('.submenu-mobile');
    var toggle = parent_parent.prev('.submenu-toggle');
    parent.removeClass('open');
    parent_parent.removeClass('open');
    toggle.removeClass('open');
  });

  // Removing Accordion open state on mobile
  if ($('#shop-accordion').length && $(window).width() <= 991) {
    $('.accordion-button').not('.collapsed').addClass('collapsed');
    $('.accordion-collapse.show').removeClass('show');
  }

  function messageFade() {
    var noticesWrapper = $(".woocommerce-notices-wrapper");
    if (noticesWrapper.length && noticesWrapper.html().trim().length > 0) {
      setTimeout(function() {
        noticesWrapper.addClass('active');
      }, 5000);
    }
  }
  
  if ($('.woocommerce-notices-wrapper').length) {
    messageFade();
  }
  
  $(document).ajaxSuccess(function(event, xhr, settings) {
    messageFade();
  });  

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };
});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");
    $(".top-bar").addClass("scroll");
  } else {
    $("header").removeClass("scroll");
    $(".top-bar").removeClass("scroll");
  }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
  if ($(".container-fix").length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1380,
    };

    let windowWidth = $(window).width();
    let containerWidth = 0;
    // let containerWidth = $(".container").width() + 32;

    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    if (containerWidth == 0) {
      console.error("containerWidth = 0 in Global.js on line: 213");
      return;
    } else {
      containerWidth += 32; // account for the padding on a bs container
    }

    // now calculate the padding for the offset on the content
    var padding = (windowWidth - containerWidth) / 2 + 16;

    if (windowWidth >= 992) {
      $(".container-fix").each(function () {
        if ($(this).hasClass("odd")) {
          $(this).css("padding-right", padding + "px");
        } else if ($(this).hasClass("even")) {
          $(this).css("padding-left", padding + "px");
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $(".container-fix").each(function () {
        $(this).css("padding-left", padding + "px");
        $(this).css("padding-right", padding + "px");
      });
    } else {
      $(".container-fix").each(function () {
        $(this).css("padding-left", "16px");
        $(this).css("padding-right", "16px");
      });
    }
  }
};

/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
  let headerHeight = $("#header").outerHeight();
  let dropdown = $(".submenu");
  let scroll = $(document).scrollTop();
  let topstripHeight = 0;

  if (scroll == 0) {
    dropdown.css("top", headerHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + headerHeight + "px");
  } else {
    dropdown.css("top", headerHeight + "px");
  }
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
  let hero = $(".offset-hero");
  let header = $("header");

  if (hero.length && header.length) {
    let height = $(header).outerHeight();
    $(hero).css("margin-top", `${height}px`);
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
  // generic slider example
  // go to - https://kenwheeler.github.io/slick/ - for documentation
  $(".slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".product-slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".single-product-slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".testimonials-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
    ],
  });

  $(".recommended-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
        }
      },
    ],
  });

  $(".recommended-nav-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    asNavFor: '.recommended-nav',
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".knowledge-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
  });

  $(".awards-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
        }
      },
    ],
  });

  $(".header-carousel").slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  $(".awards-nav-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    asNavFor: '.awards-nav',
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".services-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
  });

  // slider arrow functionality
  // $('.slick-{arrow-name}.slick-prev').click(function () {
  //   $('.{carousel-name}').slick('slickPrev');
  // });
  // $('.slick-{arrow-name}.slick-next').click(function () {
  //   $('.{carousel-name}').slick('slickNext');
  // });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#burger-homepage").toggleClass("open", open);
  $("#navigation-mobile-homepage ul").toggleClass("open", open);
  $("#navigation-mobile ul").toggleClass("open", open);
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    $marker.attr("data-lat"),
    $marker.attr("data-lng")
  );
  let icon = {
    url: "" + $marker.attr("data-icon") + "",
    scaledSize: new google.maps.Size(48, 48),
  };
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  map.markers.push(marker);
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#d3d3d3",
          },
        ],
      },
      {
        featureType: "transit",
        stylers: [
          {
            color: "#808080",
          },
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#b3b3b3",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ffffff",
          },
          {
            weight: 1.8,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d7d7d7",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ebebeb",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            color: "#a7a7a7",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#efefef",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#696969",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#737373",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d6d6d6",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {},
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#dadada",
          },
        ],
      },
    ],
    zoom: 12,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};
